import { useState } from "react";
import { Typography } from "@mui/material";
import { useNavigate } from "react-router";
import { useLocation } from "react-router";
import { getBenefits } from "@/utils/staticData/benefitsData";
import useResponsive from "@/hooks/useResponsive";

import Section from "@/components/Section";
import Stepper from "@/components/UI-Kit/Stepper";

import Close from "@/assets/icons/close.svg?react";
import Vector from "@/assets/icons/Vector.svg?react";
import Plus from "@/assets/icons/Plus.svg?react";
import TrackmateLogo from "@/assets/icons/TrackmateLogo.svg?react";
import ABI from "@/assets/icons/ABI_INSHUR_Logo_White.svg?react";
import TintBunner from "@/assets/icons/banner_tint.svg";

const Benefits = () => {

  const [isBannerVisible, setIsBannerVisible] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  const isDesktop = useResponsive("up", "lg");
  const isMobile = useResponsive("down", "md");

  const handleCloseBanner = () => {
    setIsBannerVisible(false);
  };

  return (
    <Section
      pt={{ xs: 3.5, md: 3.5, lg: 3.5 }}
      pb={{ xs: 7.5, md: 8, lg: 12.5 }}
      bgColor="background.default"
    >
      {location.pathname === "/" && (isBannerVisible || isDesktop) && (
            <div className="banner">
                <div className="bunnerBlock" style={{
                    backgroundImage: `url('${TintBunner}')`,
                }}>
                    <div className="close" onClick={handleCloseBanner}><Close /></div>
                    <div className="descriptionCard">
                        <span className="bunnerText">TrackmateGPS partners with ABI for advanced GPS and flexible car-sharing insurance!
                           <a href="https://trackmategps.com/Areas/FinanceAdministration/Content/Insurance/de45c1cd-fa86-4d31-8a6e-c7ee260ba5d4.pdf" target="_blank">
                              <span className="bunnerInfo">
                                 Learn more
                                 <Vector className="linkIcon"/>
                              </span>
                          </a>
                        </span>
                    </div>
                    <div className="logoBlock">
                        <a href="https://abiweb.com" target="_blank" rel="noopener noreferrer" style={{ display: 'flex', alignItems: 'center' }}>
                            <ABI style={{ marginTop: '9px' }}/>

                        </a>
                        <Plus/>
                        <TrackmateLogo onClick={() => {
                            navigate('/')
                        }}/>
                    </div>
                </div>
            </div>
      )}

      <Typography
        variant="h2"
        fontSize={{ xs: "1.25rem", sm: "1.5rem", md: "2rem", lg: "2.5rem" }}
        mb={{ xs: 5, md: 8, lg: 10 }}
        maxWidth={870}
        textAlign="center"
        mx={"auto"}
        sx={{ marginTop: '5rem' }}
      >
        Our user-friendly platform consolidates vehicle and asset data into a single source of truth at your fingertips, 24/7.
      </Typography>
      <Stepper steps={getBenefits(isMobile)} type="benefits" />
    </Section>
  );
};

export default Benefits;
